"use client"

import React from "react"
import clsx from "clsx"
import Icon from "ui/components/atoms/icon"
import { Label } from "ui/components/atoms/typography"
import { BaseStyles } from "ui/types/base-styles"
import { generateStylesFromProps } from "ui/utils/styles"

import styles from "./Checkbox.module.css"

export type CheckboxProps = BaseStyles & {
  name: string
  value: boolean
  label?: string
  icon?: string
  $type?: "primary" | "secondary"
  $hasBox?: boolean
  $iconSize?: string
  $iconColor?: string
  $labelIcon?: string
  onChange?: (e: { name: string; value: boolean }) => void
}

const Checkbox = ({
  name,
  value,
  label,
  icon,
  onChange = () => {},
  $type = "primary",
  $hasBox = false,
  $iconSize,
  $iconColor,
  $color,
  className = "",
  style = {},
  ...rest
}: CheckboxProps & { className?: string; style?: React.CSSProperties }) => {
  const handleOnChange = (e: boolean) => {
    onChange({
      name,
      value: e,
    })
  }

  const generatedStyles = generateStylesFromProps(rest)

  const optionClasses = clsx(
    styles.option,
    {
      [styles.secondary]: $type === "secondary",
      [styles.active]: value,
      [styles.hasBox]: $hasBox,
    },
    className,
  )

  const optionStyles = {
    ...generatedStyles,
    ...style,
  }

  const checkboxClasses = clsx(styles.checkboxWrapper, {
    [styles.active]: value,
  })

  return (
    <button
      type="button"
      onClick={() => handleOnChange(!value)}
      className={optionClasses}
      style={optionStyles}
    >
      {($type === "primary" || $hasBox) && (
        <div className={checkboxClasses}>
          <Icon icon="check" />
        </div>
      )}
      <Label
        icon={icon}
        $type="secondary"
        $iconSize={$iconSize}
        $iconColor={$iconColor}
        $textAlign="left"
        $flex={1}
        className={styles.label}
      >
        {label}
      </Label>
    </button>
  )
}

export default Checkbox
